import { createSlice , } from "@reduxjs/toolkit";

const ApiData = createSlice({
    name: "AllDoctorApi",
    initialState: [],
    reducers:{
        doctorapi(state, action){
            console.log(state, "state")
            return state = action.payload
        },
    }
})
    console.log(ApiData.actions, "state")

export const {doctorapi} = ApiData.actions;
export default ApiData.reducer;